import React from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { format } from "date-fns";
import Button from "components/Button";
import "./index.scss";

const UpdatedAtCell = ({
  value,
  row,
  expandedFarm,
  expandFarm,
  deleteFarm,
}) => {
  const formattedDate = format(new Date(value), "MMMM d, yyyy");
  const history = useHistory();

  return (
    <div data-testid="updated-at" className="updated-at">
      <ReactTooltip className="tooltip" effect="solid" />
      <div className="wrapper">
        <div className={row.isExpanded ? "cell-header" : "cell-header -hidden"}>
          Last Updated
        </div>
        <div>{formattedDate}</div>
      </div>
      <div className="actions">
        <div className="action-icons">
          <div
            data-testid="default-icon-wrapper"
            className={`icons ${row.isExpanded ? "block" : "hidden"}`}
          >
            <Button
              type="outlined"
              color="white"
              data-testid="view-farm-btn"
              size="small"
              onClick={() =>
                history.push(`/farms/${row.original.properties.farm_id}`)
              }
              label="View"
            />
            <span
              data-tip="View Farm Information"
              className="icon-redirect icon"
              onClick={() =>
                history.push(
                  `/farms/${row.original.properties.farm_id}/details`
                )
              }
              aria-hidden
            />
            <span
              data-tip="Delete Farm"
              className="icon-trash icon"
              onClick={() => {
                deleteFarm(row.original.properties);
              }}
              aria-hidden="true"
            />
          </div>
          <span
            data-testid="more-icon"
            className={`icon-more more icon ${
              row.isExpanded ? "hidden" : "block"
            }`}
          />
        </div>
        <span
          data-testid="collapse-icon"
          className={`collapse icon ${
            row.isExpanded ? "icon-chevron-up" : "icon-chevron-down"
          }`}
          {...row.getToggleRowExpandedProps({
            onClick: () => {
              row.toggleRowExpanded();

              const id = expandedFarm === row.id ? null : row.id;
              expandFarm(id);
            },
          })}
        />
      </div>
    </div>
  );
};

UpdatedAtCell.defaultProps = {
  expandedFarm: null,
};

UpdatedAtCell.propTypes = {
  value: PropTypes.string.isRequired,
  row: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  expandedFarm: PropTypes.string,
  expandFarm: PropTypes.func.isRequired,
  deleteFarm: PropTypes.func.isRequired,
};

export default UpdatedAtCell;
